import { render, staticRenderFns } from "./InvoicesPack.vue?vue&type=template&id=70cc9877"
import script from "./InvoicesPack.vue?vue&type=script&lang=js"
export * from "./InvoicesPack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports